import { render, staticRenderFns } from "./BagReplacement.vue?vue&type=template&id=5a96e4d2"
import script from "./BagReplacement.vue?vue&type=script&lang=js"
export * from "./BagReplacement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports